module.exports = __webpack_public_path__ + "c1a1e2ff63f51789d6595216ab87f2c2.jpg";